import { createContext, useContext } from 'react'

export const SurveyModalContext = createContext<{
  open: () => void
  close: () => void
  isOpen: boolean
}>({
  open: () => {},
  close: () => {},
  isOpen: false,
})

export function useSurveyModal() {
  return useContext(SurveyModalContext)
}
